import type { inspiration as inspirationEn } from "../../en/webHints/inspiration";

// Nápovědy polí a záložek editoru inspirace (řez 10). Klíče volá registr nápověd
// (`apps/admin/src/lib/webHints/inspiration.ts`). Text záznamu `web` má tvar
// „<stránka> → <sekce>“ s podmínkou, předponu „Na webu:“ přidá `FieldHint`. Text záznamu
// `backoffice` je účel, který doplňuje větu „Nezobrazuje se na webu, slouží pro …“.
export const inspiration: typeof inspirationEn = {
  title:
    "Stránka inspirace → hero a nadpis H1, když nejsou vyplněné vlastní; karta inspirace ve výpisu /inspirace, v Oblíbených inspiracích, v pásu aktivit na stránkách destinace, zájezdu a hotelu a na stránkách Kdy vyrazit",
  slug: "Stránka inspirace → adresa /inspirace/<země>/<slug>",
  activityTypes:
    "Výpis /inspirace → štítek typů na kartě a filtr typu (inspirace je pod každým svým typem); Oblíbené inspirace a výsledek hledání (jen když je zaškrtnutý aspoň jeden typ)",
  difficultyLevel:
    "Výpis /inspirace → štítek náročnosti na kartě (jen když je vyplněná); stránka inspirace ji neukazuje",
  duration:
    "Výpis /inspirace → délka na kartě (jen když je vyplněná); stránka inspirace ji neukazuje",
  destinationId:
    "Stránka inspirace → země v adrese, sekce Zájezdy, blok „<destinace> — zájezdy s CK Go2“, Kontaktujte naše specialisty, Oblíbené inspirace a Další destinace; výpis /inspirace → filtr destinace (vše jen u publikované destinace)",
  location:
    "Stránka inspirace → místo pod titulkem v hero; výpis /inspirace → místo na kartě (bez lokality název destinace)",
  heroTitle: "Stránka inspirace → velký titulek na hero obrázku (prázdný = název inspirace)",
  heading: "Stránka inspirace → hlavní nadpis H1 pod hero (prázdný = název inspirace)",
  shortDescription:
    "Stránka inspirace → perex pod nadpisem H1; karty ve výpisu /inspirace a na stránkách Kdy vyrazit; popis pro vyhledávače, když není vyplněný meta popis",
  metaTitle: "Vyhledávače a sdílení → titulek stránky inspirace (prázdný = „<název> - CK Go2“)",
  metaDescription:
    "Vyhledávače a sdílení → popis stránky inspirace (prázdný = krátký popis, pak podrobný popis)",
  featuredImageId:
    "Stránka inspirace → obrázek v hero a náhled při sdílení; obrázek karty ve výpisech a v pásu aktivit (bez obrázku hero ukáže starý obrázek z importu, a když ani ten není, ilustrační fotku)",
  sortOrder:
    "pořadí ve výpisu /inspirace a v automatickém výběru Oblíbených inspirací (nižší číslo dřív)",
  isFeatured:
    "přednost v automatickém výběru Oblíbených inspirací (po inspiracích ze stejné destinace); odznak na webu nemá",
  status: "zveřejnění: stránku na webu a místo ve výpisech má jen publikovaná inspirace",
  description: "Stránka inspirace → text pod perexem v úvodní sekci",
  galleryImageIds:
    "Stránka inspirace → Fotogalerie (v liště sekcí „Kam vyrazit“; bez obrázků ukáže staré obrázky z importu, a když ani ty nejsou, se nevykreslí)",
  included:
    "vyhledávání a návrhy úprav AI asistenta adminu; seznam „co je v ceně“ web u inspirace nezobrazuje",
  tags: "vyhledávání AI asistenta adminu v obsahu inspirací; web podle štítků nefiltruje ani je nezobrazuje",
  socialReels: "Stránka inspirace → Nechte se inspirovat (jen s reels)",
  videos:
    "Stránka inspirace → Videa (karta na každé platné video); první video spouští tlačítko „Přehrát další videa“ v bloku „<destinace> — zájezdy s CK Go2“ a v náhledu bloku je, když destinace nemá vlastní video (blok jen u publikované destinace)",
  tips: "Stránka inspirace → Užitečné tipy (každá kategorie jeden rozbalovací blok; prázdné položky se nezobrazí)",
  testimonialQuote: "Stránka inspirace → citace nad Užitečnými tipy (jen když je vyplněná)",
  testimonialAuthor:
    "Stránka inspirace → citace: podpis pod citátem (jen jméno skutečné osoby; obecný podpis typu „Go2 expert“ web nezobrazí)",
  testimonialAuthorImageId:
    "Stránka inspirace → citace: fotka u podpisu (jen když se podpis zobrazí)",
  relatedItems:
    "Stránka inspirace → Oblíbené inspirace (ruční výběr v tomto pořadí má přednost; bez něj web vybírá sám z destinace)",
  linkedTrips:
    "Stránka inspirace → Zájezdy, na kterých to zažijete (jen publikované zájezdy, před ostatními zájezdy destinace; bez vazby jen ostatní zájezdy destinace s odkazem na cestu na míru, a když nejsou ani ty, rámeček s nabídkou na míru)",
  tabIncluded: "vyhledávání a návrhy úprav AI asistenta adminu",
};
